module.exports = __webpack_public_path__ + "static/media/imgeOverlay.1b513a3c.png";